import React from 'react';
import { useApi } from 'Service/axios';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { Box } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IconPrinter, IconTrash } from '@tabler/icons';

const ActionButtonsTabela = ({ row, setOpenModalPdf, setOpenModalPdfViewer, getEntradaById, setCurrentRow, getEntradas }) => {
    /////////////////////////////// INSTANCIAS /////////////////////////
    const api = useApi();
    /////////////////////////////// STATES /////////////////////////
    const [openDialog, setOpenDialog] = useState(false);
    /////////////////////////////// FUNÇÕES /////////////////////////
    const handleDeleteEntrada = async (entradaId) => {
        try {
            await api.deleteEntradaEstoque(entradaId);
            setOpenDialog(false);
            toast.success('Entrada deletada com sucesso');
            getEntradas();
        } catch (error) {
            toast.error('Erro ao deletar entrada');
        }
    };

    return (
        <Box>
            <Dialog open={openDialog}>
                <DialogTitle sx={{ fontSize: '1.125rem', fontWeight: '500' }}>Atenção</DialogTitle>
                <DialogContent>Tem certeza que deseja excluir essa entrada?</DialogContent>
                <DialogActions>
                    <Button color="error" variant="contained" onClick={() => setOpenDialog(false)}>
                        Cancelar
                    </Button>
                    <Button variant="contained" onClick={() => handleDeleteEntrada(row.id)}>
                        Deletar
                    </Button>
                </DialogActions>
            </Dialog>
            <Tooltip title="Visualizar Nota Fiscal">
                <IconButton
                    disabled={!row?.notaFiscal}
                    onClick={() => {
                        setOpenModalPdfViewer(true);
                        setCurrentRow(row);
                    }}
                >
                    <IconPrinter />
                </IconButton>
            </Tooltip>
            <Tooltip title="Vizualizar Entrada">
                <Link to={`/main/estoque/entrada/${row.id}`}>
                    <IconButton>
                        <EditIcon />
                    </IconButton>
                </Link>
            </Tooltip>
            <Tooltip title="Deletar Entrada">
                <IconButton
                    onClick={() => {
                        setOpenDialog(true);
                    }}
                >
                    <IconTrash />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default ActionButtonsTabela;
